import { NEWS_COLORS } from "../constants/news.constants";
import type { NewsHighlight } from "../data/newsContent";

type NewsHighlightGridProps = {
  items: NewsHighlight[];
};

export function NewsHighlightGrid({ items }: NewsHighlightGridProps) {
  return (
    <ul className="mt-6 grid gap-3 sm:grid-cols-2 lg:grid-cols-4">
      {items.map(({ title, description, Icon }) => (
        <li
          key={title}
          className="flex items-start gap-3 rounded-2xl border border-gray-100 bg-white p-4 shadow-sm"
        >
          <span
            className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full"
            style={{
              backgroundColor: NEWS_COLORS.primarySoft,
              color: NEWS_COLORS.primary,
            }}
          >
            <Icon className="h-5 w-5" aria-hidden />
          </span>
          <div className="min-w-0">
            <p className="text-sm font-bold text-gray-900">{title}</p>
            <p className="mt-0.5 text-xs leading-snug text-gray-500">
              {description}
            </p>
          </div>
        </li>
      ))}
    </ul>
  );
}
